import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import { canNavigate } from "@/libs/acl/routeProtection";

Vue.use(VueRouter);

const convertTitles = function () {
  let breadTitles = store.getters["breadcrumb/breadcrumbs"];
  const currentTitles = store.getters["breadcrumb/currentBreadcrumb"];
  breadTitles = breadTitles.map((breadTitle) => {
    return Object.assign({}, breadTitle, {
      active: false,
    });
  });

  for (let i = currentTitles.length; i > 0; i--) {
    breadTitles[breadTitles.length - i] = Object.assign(
      {},
      breadTitles[breadTitles.length - i],
      {
        active: true,
      }
    );
  }
  return breadTitles;
};
window.popStateDetected = false;
window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // path: "/:lang",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "",
      name: "home",
      component: () => import("@/views/Home.vue"),
      meta: {
        requireAuth: true,
        pageTitle: "homePage",
        resource: "dashboard",
        actions: "read",
        breadCrumb() {
          return convertTitles();
        },
        // breadCrumb(route) {
        //   return [
        //     {
        //       text: 'homePage',
        //       active: true,
        //         translate:true
        //     }
        //
        //   ]
        // }
      },
      children: [],
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/authentication/Login.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/changePassword",
      name: "changePassword",
      component: () => import("@/views/changePassword/ChangePassword.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/profile",
      name: "profile",
      meta: { requireAuth: true },
      component: () => import("@/views/profile/Profile.vue"),
    },
    {
      path: "/users",
      name: "users",
      meta: { requireAuth: true },
      component: () => import("@/views/users/Users.vue"),
      children: [
        {
          path: "/",
          name: "manageUsers",
          meta: {
            requireAuth: true,
            resource: "users",
            action: "read",
            breadCrumb() {
              return convertTitles();
            },
          },

          component: () => import("@/views/users/Manage.vue"),
        },
        {
          path: "add",
          name: "addUser",
          meta: {
            requireAuth: true,
            breadCrumb() {
              return convertTitles();
            },
            resource: "users",
            action: "create",
          },
          component: () => import("@/views/users/Add.vue"),
        },
        {
          path: "edit/:id",
          name: "editUser",
          meta: {
            requireAuth: true,
            breadCrumb() {
              return convertTitles();
            },
            resource: "users",
            action: "update",
          },
          component: () => import("@/views/users/Edit.vue"),
        },
        {
          path: "changePassword/:id",
          name: "changeOtherUsersPassword",
          meta: {
            requireAuth: true,
            breadCrumb() {
              return convertTitles();
            },
            resource: "users",
            action: "passwordChange",
          },
          component: () => import("@/views/users/ChangePassword.vue"),
        },
      ],
    },
    {
      path: "/permission",
      name: "permission",
      meta: { requireAuth: true },
      component: () => import("@/views/permission/Permission.vue"),
      children: [
        {
          path: "/permissions",
          name: "permissions",
          meta: {
            requireAuth: true,
          },
          component: () =>
            import("@/views/permission/permissions/Permissions.vue"),
          children: [
            {
              path: "/",
              name: "managePermissions",
              meta: {
                requireAuth: true,
                resource: "permissions",
                action: "read",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/permission/permissions/Manage.vue"),
            },
            {
              path: "add",
              name: "addPermissions",
              meta: {
                requireAuth: true,
                resource: "permissions",
                action: "create",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () => import("@/views/permission/permissions/Add.vue"),
            },
            {
              path: "assignPermission/:userId",
              name: "assignPermission",
              meta: {
                requireAuth: true,
                resource: "users",
                action: "addPermissions",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/permission/permissions/Assing.vue"),
            },
            {
              path: "edit/:permissionId",
              name: "editPermission",
              component: () =>
                import("@/views/permission/permissions/Edit.vue"),
            },
          ],
        },
        {
          path: "/permissionUnits/:userId",
          name: "permissionUnits",
          meta: {
            requireAuth: true,
            resource: "users",
            action: "addPermissions",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/permission/PermissionUnits.vue"),
        },
        {
          path: "/permissionRooms/:userId",
          name: "permissionRooms",
          meta: {
            requireAuth: true,
            resource: "users",
            action: "addPermissions",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/permission/permissionRooms.vue"),
        },
        {
          path: "/permissionGroups",
          name: "permissionGroups",
          meta: { requireAuth: true },
          component: () =>
            import("@/views/permission/permissionGroups/PermissionGroups.vue"),
          children: [
            {
              path: "/",
              name: "managePermissionGroups",
              meta: {
                requireAuth: true,
                resource: "permissionGroups",
                action: "read",
                breadCrumb() {
                  return convertTitles();
                },
              },

              component: () =>
                import("@/views/permission/permissionGroups/Manage.vue"),
            },
            {
              path: "add",
              name: "addPermissionGroups",
              meta: {
                requireAuth: true,
                resource: "permissionGroups",
                action: "create",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/permission/permissionGroups/Add.vue"),
            },
            {
              path: "edit/:groupId",
              name: "editPermissionGroups",
              component: () =>
                import("@/views/permission/permissionGroups/Edit.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/doctors",
      name: "doctors",
      meta: {
        requireAuth: true,
      },
      component: () => import("@/views/doctors/Doctors.vue"),
      children: [
        {
          path: "/",
          name: "manageDoctors",
          meta: {
            requireAuth: true,
            action: "read",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/doctors/Manage.vue"),
        },
      ],
    },
    {
      path: "/patients",
      name: "patients",
      meta: {
        requireAuth: true,
      },
      component: () => import("@/views/patients/Patients.vue"),
      children: [
        {
          path: "/",
          name: "managePatients",
          meta: {
            requireAuth: true,
            action: "read",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/patients/Manage.vue"),
        },
        {
          path: "edit/:id",
          name: "editPatient",
          meta: {
            requireAuth: true,
            action: "update",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/patients/Edit.vue"),
        },
      ],
    },
    {
      path: "/structure",
      name: "structure",
      meta: { requireAuth: true },
      component: () => import("@/views/baseInfo/structure/Structure.vue"),
      children: [
        {
          path: "sections",
          name: "sections",
          meta: { requireAuth: true },
          component: () =>
            import("@/views/baseInfo/structure/sections/Section.vue"),
          children: [
            {
              path: "/",
              name: "manageSection",
              meta: {
                requireAuth: true,
                resource: "sections",
                action: "read",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/baseInfo/structure/sections/Manage.vue"),
            },
            {
              path: "add",
              name: "addSection",
              meta: {
                requireAuth: true,
                resource: "sections",
                action: "create",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/baseInfo/structure/sections/Add.vue"),
            },
            {
              path: "edit/:id",
              name: "editSection",
              meta: {
                requireAuth: true,
                resource: "sections",
                action: "update",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/baseInfo/structure/sections/Edit.vue"),
            },
          ],
        },
        {
          path: "units",
          name: "units",
          meta: { requireAuth: true },
          component: () => import("@/views/baseInfo/structure/units/Unit.vue"),
          children: [
            {
              path: "/",
              name: "manageUnit",
              meta: {
                requireAuth: true,
                resource: "units",
                action: "read",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/baseInfo/structure/units/Manage.vue"),
            },
            {
              path: "add",
              name: "addUnit",
              meta: {
                requireAuth: true,
                resource: "units",
                action: "create",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/baseInfo/structure/units/Add.vue"),
            },
            {
              path: "edit/:id",
              name: "editUnit",
              meta: {
                requireAuth: true,
                resource: "units",
                action: "update",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/baseInfo/structure/units/Edit.vue"),
            },
          ],
        },
        {
          path: "medical-specialties",
          name: "medicalSpecialties",
          meta: { requireAuth: true },
          component: () =>
            import(
              "@/views/baseInfo/medicalSpecialties/medicalSpecialties.vue"
            ),
          children: [
            {
              path: "/",
              name: "manageMedicalSpecialties",
              meta: {
                requireAuth: true,
                resource: "medicalSpecialties",
                action: "read",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/baseInfo/medicalSpecialties/Manage.vue"),
            },
            {
              path: "add",
              name: "addMedicalSpecialties",
              meta: {
                requireAuth: true,
                resource: "medicalSpecialties",
                action: "create",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/baseInfo/medicalSpecialties/Add.vue"),
            },
            {
              path: "edit/:id",
              name: "editMedicalSpecialties",
              meta: {
                requireAuth: true,
                resource: "medicalSpecialties",
                action: "update",
                breadCrumb() {
                  return convertTitles();
                },
              },
              component: () =>
                import("@/views/baseInfo/medicalSpecialties/Edit.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/holidays",
      name: "holidays",
      meta: { requireAuth: true },
      component: () => import("@/views/baseInfo/holidays/holidays.vue"),
      children: [
        {
          path: "/",
          name: "manageHolidays",
          meta: {
            requireAuth: true,
            action: "read",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/baseInfo/holidays/Manage.vue"),
        },
        {
          path: "add",
          name: "addHoliday",
          meta: {
            requireAuth: true,
            resource: "holidays",
            action: "create",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () =>
            import("@/views/baseInfo/holidays/Add.vue"),
        },
        {
          path: "edit/:id",
          name: "editHoliday",
          meta: {
            requireAuth: true,
            resource: "holidays",
            action: "update",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () =>
            import("@/views/baseInfo/holidays/Edit.vue"),
        },
        
      ],

    },
    {
      path: "/settings",
      name: "settings",
      meta: {
        requireAuth: true,
      },
      component: () => import("@/views/settings/Settings.vue"),
      children: [
        {
          path: "/",
          name: "manageSettings",
          meta: {
            requireAuth: true,
            action: "read",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/settings/Manage.vue"),
        },
      ],
    },
    {
      path: "/calendar",
      name: "calendar",
      meta: {
        requireAuth: true,
      },
      component: () => import("@/views/calendar/Calendar.vue"),
      children: [
        {
          path: "/",
          name: "manageCalendar",
          meta: {
            requireAuth: true,
            action: "read",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/calendar/Manage.vue"),
        },
      ],
    },
    {
      path: "/AppointmentOfPatients",
      name: "AppointmentOfPatients",
      meta: {
        requireAuth: true,
      },
      component: () =>
        import("@/views/AppointmentOfPatients/AppointmentOfPatients.vue"),
      children: [
        {
          path: "/",
          name: "manageAppointmentOfPatients",
          meta: {
            requireAuth: true,
            action: "read",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/AppointmentOfPatients/Manage.vue"),
        },
      ],
    },
    {
      path: "/turnCounter",
      name: "turnCounter",
      meta: {
        layout: "full",
      },
      component: () =>
        import("@/views/turnCounter/turnCounter.vue"),
      children: [
        {
          path: "/",
          name: "manageturnCounter",
          meta: {
            layout: "full",
          },
          component: () => import("@/views/turnCounter/Manage.vue"),
        },
      ],
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-403",
      name: "error-403",
      component: () => import("@/views/error/Error403.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
    {
      path: "/messages",
      meta: { requireAuth: true },
      component: () => import("@/views/message/message.vue"),
      children: [
        {
          path: "/",
          name: "manageMessages",
          meta: {
            requireAuth: true,
            resource: "message",
            action: "read",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/message/Manage.vue"),
        },
        {
          path: "edit/:id",
          name: "editMessage",
          meta: {
            requireAuth: true,
            resource: "message",
            action: "update",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/message/Edit.vue"),
        },
        {
          path: "/Add",
          name: "addMessage",
          meta: {
            requireAuth: true,
            resource: "message",
            action: "create",
            breadCrumb() {
              return convertTitles();
            },
          },
          component: () => import("@/views/message/Add.vue"),
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const IsItABackButton = window.popStateDetected;
  window.popStateDetected = false;
  // try{

  if (window.popStateDetected) {
    window.popStateDetected = false; 
    next(false); 
  } else {
    next();
  }
  let prev = {};
  prev.matched = [];
  if (from.path !== "/") {
    from.matched.length
      ? from.matched.forEach((m, index) => {
          prev.matched[index] = {};
          prev.matched[index].path = m.path;
        })
      : "";
    prev.fullPath = from.fullPath;
    prev.name = from.name;
    prev.params = from.params;
    prev.path = from.path;
  } else {
    to.matched.length
      ? to.matched.forEach((m, index) => {
          prev.matched[index] = {};
          prev.matched[index].path = m.path;
        })
      : "";
    prev.fullPath = to.fullPath;
    prev.name = to.name;
    prev.params = to.params;
    prev.path = to.path;
  }
  localStorage.setItem("prevRoute", JSON.stringify(prev));
  // }
  // catch(e){
  //   localStorage.setItem("prevRoute", from);
  //
  // }
  if (from.fullPath === "/") {
    store.commit("breadcrumb/REMOVE_CURRENT_BREADCRUMB");
  }
  if (to.meta.requireAuth) {
    if (!canNavigate(to)) {
      if (to.name === "home") {
        next({ name: "login" });
      } else {
        next({ name: "error-403" });
      }
    }
    // if (cookie.get("token")) {
    else if (localStorage.getItem("token")) {
      if (IsItABackButton) {
        next(false);
        // store.commit("breadcrumb/REMOVE_CURRENT_BREADCRUMB");
        // store.commit("breadcrumb/SET_CURRENT_BREADCRUMB", [
        //   store.getters["breadcrumb/breadcrumbs"][
        //     store.getters["breadcrumb/breadcrumbs"].length - 1
        //   ],
        // ]);
      } else {
        next();
      }
    } else {
      next({ name: "login" });
    }
  } else {
    next();
  }
});

export default router;
